export const MAX_MOBILE_DEVICE_WIDTH = 480;
export const STANDARD_SCREEN_WIDTH = 1920;
